
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CurrencyHelper } from '@/helpers/CurrencyHelper';

interface LandedCostComponents {
  method: 'ratio' | 'proportional';
  unit_price?: number;
  effective_unit_price?: number;
  discount_factor?: number;
  landed_cost_ratio?: number;
  discounted_subtotal?: number;
  shipping_cost?: number;
  adjustment_amount?: number;
  shipping_per_unit?: number;
  adjustment_per_unit?: number;
  formula?: string;
}

@Component
export default class LandedCostBreakdown extends Vue {
  @Prop({ type: Object, required: true }) components!: LandedCostComponents;
  @Prop({ type: Number, required: true }) quantity!: number;
  @Prop({ type: Number, required: true }) landedCost!: number;

  /** Coerce a value to a number, returning 0 for undefined/null/NaN. */
  n(value: any): number {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  get hasDiscount(): boolean {
    const factor = this.n(this.components.discount_factor);
    return factor > 0 && factor < 1;
  }

  /** For proportional: discount amount per unit = unit_price - effective_unit_price */
  get discountPerUnit(): number {
    return Math.round((this.n(this.components.unit_price) - this.n(this.components.effective_unit_price)) * 100) / 100;
  }

  formatCurrency(value: number | undefined): string {
    return CurrencyHelper.formatCurrency(value);
  }
}
